import { AnyAction } from "redux";
import { takeLatest, call, put, takeEvery } from "redux-saga/effects";
import {
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGIN_COMPLETE,
  UPDATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_SUCCESS,
} from "../../common/redux/actions";
import { USERS_URL } from "../config";
import Persistence, { getAllExperimentalFeatures } from "../persistence";
import { loadedExperimentalFeatures, LOCAL_LOGIN_START } from "./actions";
import localExperimentalFeatures from "../experimentalFeatures.json";

const fetchExperimentalFeatures = async () => {
  const response = await getAllExperimentalFeatures();
  return response;
};

const fetchUserFeatures = async (upn: string, token: string) => {
  try {
    const url = `${USERS_URL}/users/${upn}/experimental-features`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });

    if (response.ok)
      return await response.json();
    else
      return localExperimentalFeatures;
  } catch (_) {
    return localExperimentalFeatures;
  }
};

function* completeLogin({ payload }: AnyAction) {
  yield call(
    () => new Promise<void>((resolve) => setTimeout(() => resolve(), 200))
  );
  const allExperimentalFeatures: any[] = yield call(fetchExperimentalFeatures);
  const userWithExperimentalFeatures = {
    ...payload,
    userExperimentalFeatures: allExperimentalFeatures
  }
  yield put({ type: LOGIN_COMPLETE, payload: userWithExperimentalFeatures });
}

function* logout() {
  yield call(() => Persistence.setCurrentUser(null));
  yield put({ type: LOGOUT_SUCCESS });
}

function* userSubscriptionSaga({ payload }: AnyAction) {
  yield call(
    () => new Promise<void>((resolve) => setTimeout(() => resolve(), 200))
  );
  yield put({ type: UPDATE_SUBSCRIPTION_SUCCESS, payload });
}

function* refreshExperimentalFeatures() {
  const { token, upn } = Persistence.getCurrentUser();
  const features: { [key: string]: any }[] = yield call(fetchUserFeatures, upn, token);
  yield put(loadedExperimentalFeatures(features))
}

export function* rootSaga() {
  yield takeLatest(LOCAL_LOGIN_START, completeLogin);
  yield takeLatest(LOGIN_COMPLETE, refreshExperimentalFeatures)
  yield takeLatest(LOGOUT, logout);
  yield takeEvery(UPDATE_SUBSCRIPTION, userSubscriptionSaga);
}
